import * as React from "react";
import { useApiKeys } from "./useApiKeys";
import { SectionHeader } from "app/components/sectionHeader";
import { InputEdit } from "app/components/inputEdit/InputEdit";

export interface ApiKeysProps {}

export const ApiKeys: React.FC<ApiKeysProps> = () => {
  const { account, onUpdateAccount } = useApiKeys();
  return (
      <>
        <div>
          <h4 className="text-base font-medium text-gray-900 mb-4">Payment Processor</h4>
          <div className="space-y-4">
            <div className="p-4 border border-gray-200 rounded-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Auth Key
                  </label>
                  <InputEdit
                      defaultValue={account?.iposAuthKey}
                      name="iposAuthKey"
                      onSave={(value) => onUpdateAccount({ ...value })}
                      valueClassName="text-body-bold font-body-bold text-neutral-900"
                      valueShownWhenNotEditing={account?.iposAuthKey?.replace(
                          /./g,
                          "*"
                      )}
                      isEditing={!account?.iposAuthKey}
                  />

                  {/*<input*/}
                  {/*    type="password"*/}
                  {/*    placeholder="Enter your payment processor API key"*/}
                  {/*    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
                  {/*/>*/}
                  <p className="text-xs text-gray-500 mt-1">Your primary API key for payment processing</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Ipos TPin
                  </label>
                  {/*<input*/}
                  {/*    type="password"*/}
                  {/*    placeholder="Enter your API key pin"*/}
                  {/*    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
                  {/*/>*/}
                  <InputEdit
                      defaultValue={account?.iposTpn}
                      name="iposTpn"
                      onSave={(value) => onUpdateAccount({ ...value })}
                      valueClassName="text-body-bold font-body-bold text-neutral-900"
                      valueShownWhenNotEditing={account?.iposTpn?.replace(
                          /./g,
                          "*"
                      )}
                      isEditing={
                        !!(!account?.iposTpn && account?.iposAuthKey)
                      }
                  />

                  <p className="text-xs text-gray-500 mt-1">Security T-pin for authentication</p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                   Ipos Auth Token
                  </label>

                  <InputEdit
                      defaultValue={account?.iposAuthToken}
                      name="iposAuthToken"
                      onSave={(value) => onUpdateAccount({ ...value })}
                      valueClassName="text-body-bold font-body-bold text-neutral-900"
                      valueShownWhenNotEditing={account?.iposAuthToken?.replace(
                          /./g,
                          "*"
                      )}

                      isEditing={
                        !!(
                            !account?.iposAuthToken &&
                            account?.iposTpn &&
                            account?.iposAuthKey
                        )
                      }
                  />

                  {/*<input*/}
                  {/*    type="password"*/}
                  {/*    placeholder="Enter your tokenization API key"*/}
                  {/*    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"*/}
                  {/*/>*/}
                  <p className="text-xs text-gray-500 mt-1">Token</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </>





  );
};
